import { Col, Row } from '@digitools/honest-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DataRow = ({ label, value, ...rest}) => {
  return (
    <Row className={'mr-0'} style={{ marginBottom: '.5rem', marginTop: '0rem' }}>
      <Col>{label}</Col>
      <Col style={{ textAlign: 'right' }} {...rest}>{value}</Col>
    </Row>
  );
};

const WagesDetails = ({ claimPayment }) => {
  const { t } = useTranslation();
  return (
    <>
      <DataRow label={<strong>Wages</strong>} value={<strong>Taxable</strong>} />
      <DataRow label={t('checkFederalTaxWithheldAmountText')} value={claimPayment.federalWage} data-private={true}/>
      <DataRow label={t('checkMedicareTaxWithheldAmountText')} value={claimPayment.medicareWage} data-private={true}/>
      <DataRow label={t('checkSsoaiTaxWithheldAmountText')} value={claimPayment.ssoiWage} data-private={true}/>
      <DataRow label={t('checkStateTaxWithheldAmountText')} value={claimPayment.stateWage} data-private={true}/>
      <DataRow label={''} value={<strong>Non-Taxable</strong>} />
      <DataRow label={t('checkFederalTaxWithheldAmountText')} value={claimPayment.nonTaxableFederal} data-private={true}/>
    </>
  );
};

export default WagesDetails;
